export default {
  p1: [
    'Clinical data management (CDM) is a crucial part of clinical research that has been established'
    + 'out of the need for a faster and error-free drug evaluation process. The main purpose of clinical'
    + 'data management is to collect, validate, manage, and prepare clinical data for statistical'
    + 'analysis. The data management and monitoring should comply with the accepted international'
    + 'quality assurance standards.',
    'STATECS team provides high-quality clinical data management services that meet the SDTMIG'
    + '(Study Data Tabulation Model Implementation Guide for Human Clinical Trials) and CDASH'
    + '(Clinical Data Acquisition Standards Harmonization) standards. The former is to be complied'
    + 'with as per the mandate of the FDA. The latter helps simplify the way data submissions are'
    + 'tracked and reviewed.',
  ],
  p2: [
    {
      title: 'How Our Clinical Data Managers Handle the Process',
      context: 'At STATECS, we value both our and our customers’ time and strive to deliver the highest quality'
        + 'data management services possible. Our team is made up of experienced data managers,'
        + 'database programmers, quality control associates, and data entry associates who are fully'
        + 'committed to the work they do and will ensure timely and accurate delivery of all the data'
        + 'management services that you need.',
    },
  ],
  p3: [
    'Clinical data management needs to be implemented right at the onset of clinical trials. The'
    + 'process includes the following stages:',
    '●\tDetermination of data fields to be used',
    '●\tDevelopment of a data management plan',
    '●\tDatabase building aimed at supporting various CDM tasks',
    '●\tData management plan testing',
    '●\tCFR (Code of Federal Regulations) tracking',
    '●\tData entry',
    '●\tValidation',
    '●\tDiscrepancy management',
    '●\tDatabase locking',
  ],
  p4: [
    'Clinical data management is a complex process and needs to be done thoroughly with high'
    + 'attention to detail otherwise you risk failing in the provision of accurate data. The latter is of'
    + 'critical importance when it comes to clinical research, drug evaluation, patient health and safety,'
    + 'and the overall improvement of healthcare.',
    'Our data managers will ensure the smooth processing of your data by providing you with'
    + 'end-to-end all-inclusive clinical data management services. We work with the world’s most'
    + 'prominent pharmaceutical companies toward the common goal of making the world a healthier'
    + 'and safer place for generations to come.',
  ],
  p5: [
    {
      title: 'Our Clinical Data Management Services',
      context: 'STATECS covers the full spectrum of services needed to execute successful clinical data'
        + 'management.',
    },
  ],
  p6: [
    'Our services include but are not limited to:',
    '●\tCDISC/CDASH compliant CRF/eCRF design, monitoring, and maintenance',
    '●\tSetup and implementation of medical coding',
    '●\tElectronic data collection',
    '●\tData management plan development',
    '●\tDevelopment of SAS listing',
    '●\teSource & ePRO/eCOA',
    '●\tWearable sensor data flow',
    '●\tCreation and maintenance of data query',
    '●\tImport and reconciliation of external data to ensure that the information has been'
    + 'transferred correctly',
  ],
  p7: [
    'By choosing STATECS as your clinical data management provider, you choose a trustworthy and'
    + 'reliable partner that guarantees a fruitful collaboration. Thanks to our flexible electronic data'
    + 'capture (EDC) technologies you will not only have high-quality data at hand for further research'
    + 'but will also be able to access it in real-time from various sources.',
    'We use the latest technologies to improve patient experience and ensure on-time clinical data'
    + 'delivery that complies with all regulatory standards and helps improve the global healthcare'
    + 'system.',
  ],
};
